import { css } from 'linaria';

export const sizeStylesMap = {
  l: css`
    left: 24px;
    right: 24px;
    bottom: 24px;

    @media (--only-mobile) {
      left: 20px;
      right: 20px;
      bottom: 20px;
    }
  `,
  m: css`
    left: 16px;
    right: 16px;
    bottom: 16px;
  `,
};

export const imageNameContainer = css`
  position: absolute;
  width: fit-content;
  padding: 8px 10px;
  background: rgb(0 0 0 / 15%);
  border-radius: var(--rounding-m);
  backdrop-filter: blur(40px);
`;

export const imageAddText = css`
  && {
    margin-top: 4px;
  }
`;
